export const environment = {
  production: true,
  apiUrl: 'https://api.qode.qa/api',
  baseUrl: 'https://api.qode.qa',
  redirectUrl: 'https://servio-menu.qode.qa',
  templateUrl: 'https://servio-landing.qode.qa'
};
